import { Form, FormItemProps } from 'antd';

import './style.less';

export default function FormItemBorder(props: FormItemProps) {
  return (
    <Form.Item
      {...props}
      className="form-item-border"
      style={{ marginBottom: 0 }}
    />
  );
}
